module.exports = __webpack_public_path__ + "static/img/icon_dropdown_down_20_normal_white.6117b31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_dropdown_down_20_normal_white.svg
// module id = UfWz
// module chunks = 10